import axios from "axios";
import {
    GET_ALL_VOUCHERS,
    GET_USED_VOUCHERS,
    GET_UNUSED_VOUCHERS,
    VOUCHERS_FAILED,
} from "./types";

export const getVouchers = () => async (dispatch) => {
    try {
        let data = await axios.get("/getallvouchers");
        // let vouchers = data.data.vouchers;
        // console.log(data.data.transactions);
        dispatch({
            type: GET_ALL_VOUCHERS,
            payload: data.data.vouchers,
        });

    } catch (err) {
        dispatch({
            type: VOUCHERS_FAILED,
        });
        console.log(err);
    }
};

export const getUsedVouchers = () => async (dispatch) => {
    try {
        let data = await axios.get("/getusedvouchers");
        // console.log(data.data.transactions);
        dispatch({
            type: GET_USED_VOUCHERS,
            payload: data.data.vouchers,
        });

    } catch (err) {
        dispatch({
            type: VOUCHERS_FAILED,
        });
        console.log(err);
    }
};

export const getUnUsedVouchers = () => async (dispatch) => {
    try {
        let data = await axios.get("/getunusedvouchers");
        // console.log(data.data.transactions);
        dispatch({
            type: GET_UNUSED_VOUCHERS,
            payload: data.data.vouchers,
        });

    } catch (err) {
        dispatch({
            type: VOUCHERS_FAILED,
        });
        console.log(err);
    }
};